import React from "react";
import { useNavigate } from "react-router-dom";
import { useScope } from "@/context/ScopeContext";

function stopRowClick(e) {
  // Many tables have clickable rows; prevent link clicks from triggering row handlers.
  e.stopPropagation();
}

const parseScopeFromPath = (to) => {
  if (!to) return null;
  const parts = String(to).split("/").filter(Boolean);
  if (parts[0] === "district" && parts[1]) return { districtCode: parts[1], districtName: "" };
  if (parts[0] === "block" && parts[1]) return { blockCode: parts[1], blockName: "" };
  if (parts[0] === "school" && parts[1]) return { udiseCode: parts[1], schoolName: "" };
  return null;
};

export const DrilldownLink = ({ to, children, className = "", scopeExtra = null }) => {
  const { setScope } = useScope();
  const navigate = useNavigate();
  if (!to && !scopeExtra) return <span className={className}>{children}</span>;

  const handleClick = (e) => {
    stopRowClick(e);
    const scopeUpdate = parseScopeFromPath(to);
    if (scopeUpdate || scopeExtra) setScope({ ...(scopeUpdate || {}), ...(scopeExtra || {}) });
    if (to) navigate(to);
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`text-blue-700 hover:underline underline-offset-2 ${className}`}
    >
      {children}
    </button>
  );
};

export const DistrictLink = ({ districtCode, children, className }) => (
  <DrilldownLink to={districtCode ? `/district/${districtCode}` : ""} className={className}>
    {children}
  </DrilldownLink>
);

export const BlockLink = ({ blockCode, blockName, children, className }) => (
  <DrilldownLink
    to={blockCode ? `/block/${blockCode}` : ""}
    scopeExtra={blockName ? { blockName, ...(blockCode ? { blockCode } : {}) } : null}
    className={className}
  >
    {children}
  </DrilldownLink>
);

export const SchoolLink = ({ udiseCode, children, className }) => (
  <DrilldownLink to={udiseCode ? `/school/${udiseCode}` : ""} className={className}>
    {children}
  </DrilldownLink>
);


